import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const Redirect = props => {

  const { url } = props
  const navigate = useNavigate()

  useEffect(() => {

    navigate(url)
    
  }, [])

  return (<></>)
}